export enum CmpConfigPublisherStandardPurposeField {
    ID = "id",
    LEGAL_BASIS = "legalBasis",
}
